import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useBlogs } from '../../../common/BlogContext';

function LatestPosts() {
  const { blogs } = useBlogs();
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const latest = [...blogs]
    .filter((b) => b.publish_date)
    .sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))
    .slice(0, 2);

  useEffect(() => {
    if (!swiperRef.current || latest.length === 0) return;
    if (typeof window.Swiper === 'undefined') return;

    const swiper = new window.Swiper(swiperRef.current, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: latest.length > 1,
      navigation: {
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      },
      breakpoints: {
        768: { slidesPerView: 2 },
      },
    });

    return () => {
      try { swiper.destroy(true, true); } catch (_) {}
    };
  }, [latest.length]);

  return (
    <section className="tc-latest-posts-style1">
      <div className="container">
        <div className="content">
          <div className="title mb-70 wow fadeInUp slow" data-wow-delay="0.2s">
            <div className="row">
              <div className="col-lg-8">
                <h3 className="fsz-45 text-capitalize"> Latest Articles </h3>
              </div>
              <div className="col-lg-4 mt-4 mt-lg-0">
                <div className="arrows me-lg-0 ms-lg-auto">
                  <div ref={prevRef} className="swiper-button-prev"></div>
                  <div ref={nextRef} className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>

          <div ref={swiperRef} className="posts-slider swiper wow fadeInUp slow" data-wow-delay="0.2s">
            <div className="swiper-wrapper">
              {latest.length === 0 ? (
                <div className="swiper-slide">
                  <p style={{ color: '#999', padding: '20px 0' }}>
                    No articles yet. <Link to="/admin">Add one in Admin →</Link>
                  </p>
                </div>
              ) : (
                latest.map((item) => {
                  const date = item.publish_date ? new Date(item.publish_date) : null;
                  const dayNum = date ? date.getDate() : '—';
                  const dateRest = date
                    ? date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    : '';
                  const tags = item.category
                    ? item.category.split(/[,\s]+/).filter(Boolean)
                    : [];

                  return (
                    <div key={item.id} className="swiper-slide">
                      <div className="post-card">
                        <Link
                          to={`/blog/${item.id}`}
                          className="img radius-7 overflow-hidden th-400 d-block"
                        >
                          {item.img ? (
                            <img src={item.img} alt={item.title} className="img-cover" />
                          ) : (
                            <div
                              className="img-cover"
                              style={{
                                background: '#f0f0ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: '#c4b5fd',
                                fontSize: 40,
                              }}
                            >
                              <i className="ti ti-photo" aria-hidden="true"></i>
                            </div>
                          )}
                        </Link>

                        <div className="info pt-50">
                          <div className="row">
                            <div className="col-lg-3">
                              <div className="date">
                                <h2 className="num fsz-45 fw-400 mb-10">{dayNum}</h2>
                                <p className="txt fsz-12 color-666 text-uppercase">
                                  {dateRest}
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-9">
                              <div className="cont">
                                <h3 className="fsz-24">
                                  <Link to={`/blog/${item.id}`} className="hover-orange1">
                                    {item.title}
                                  </Link>
                                </h3>
                                <div className="tags fsz-12 color-orange1 text-uppercase mt-20">
                                  {tags.map((tag, j) => (
                                    <span key={j}> {tag}{j < tags.length - 1 ? ',' : ''} </span>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default LatestPosts;